<template>
  <div class="body">
    <div class="bg-white p20">
      <!-- <h2 class="body-title">添加培训计划</h2> -->
      <div class="f--c mb20">
        <h2>
          基本信息
          <span class="required">*</span>
        </h2>
        <div class="hr"></div>
      </div>
      <el-form ref="form" :rules="rules" :model="form" label-width="80px">
        <el-row>
          <el-col :span="24" class="pr20">
            <el-form-item label="培训名称" prop="trainingName" class="item">
              <el-input
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="pr20">
            <el-form-item label="课程类型" prop="trainingCategoryName">
              <el-input
                @focus="showSelectTreeCategoryVisible"
                ref="trainingCategoryInput"
                clearable
                :disabled="$route.query.type == 'check'"
                v-model="form.trainingCategoryName"
              >
              </el-input>
              <selectTrainingCategory ref="selectTrainingCategory"
                                      @submit="selectTrainingCategorySubmitHandle"   :allRequired="true"></selectTrainingCategory>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="目录" prop="directoryId">
              <selectTree
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList"
                :value="form.directoryId"
                :disabled="$route.query.type == 'check'"
                @getValue="selectTreeChange"
              ></selectTree>
            </el-form-item>
          </el-col>
        </el-row>

        <!--          <el-col :span="6" class="pr20">-->
        <!--            <el-form-item label="实施日期" prop="implementationDateTime">-->
        <!--              <el-date-picker-->
        <!--                :disabled="$route.query.type == 'check'"-->
        <!--                value-format="timestamp"-->
        <!--                v-model="form.implementationDateTime"-->
        <!--                type="datetime"-->
        <!--                placeholder="选择日期"-->
        <!--              ></el-date-picker>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->

        <!--          <el-col :span="6" class="pr20">-->
        <!--            <el-form-item label="部门" prop="departmentId" class="item">-->
        <!--              <selectTree-->
        <!--                ref="selectTree"-->
        <!--                :props="{-->
        <!--                  value: 'id', // ID字段名-->
        <!--                  label: 'text', // 显示名称-->
        <!--                  children: 'children' // 子级字段名-->
        <!--                }"-->
        <!--                :options="deptTree"-->
        <!--                :value="form.departmentId"-->
        <!--                @getValue="deptChange"-->
        <!--              ></selectTree>-->
        <!--              &lt;!&ndash; <el-select-->
        <!--                :disabled="$route.query.type == 'check'"-->
        <!--                v-model="form.departmentId"-->
        <!--                placeholder="请选择"-->
        <!--              >-->
        <!--                <el-option-->
        <!--                  v-for="item in departmentList"-->
        <!--                  :key="item.id"-->
        <!--                  :label="item.deptName"-->
        <!--                  :value="item.id"-->
        <!--                ></el-option>-->
        <!--              </el-select> &ndash;&gt;-->
        <!--            </el-form-item>-->
        <!--          </el-col> -->

        <!--        <el-row>-->
        <!--          <el-col :span="6" class="pr20">-->
        <!--            <el-form-item label="负责人" prop="principalId" class="item">-->
        <!--              <el-select-->
        <!--                :disabled="$route.query.type == 'check'"-->
        <!--                v-model="form.principalId"-->
        <!--                placeholder="请选择"-->
        <!--              >-->
        <!--                <el-option-->
        <!--                  v-for="item in principalList"-->
        <!--                  :key="item.id"-->
        <!--                  :label="item.userName"-->
        <!--                  :value="item.id"-->
        <!--                ></el-option>-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--          <el-col :span="6" class="pr20">-->
        <!--            <el-form-item label="地点" prop="location" class="item">-->
        <!--              <el-input-->
        <!--                :disabled="$route.query.type == 'check'"-->
        <!--                v-model="form.location"-->
        <!--              ></el-input>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->


        <el-row>
          <el-col :span="20" class="pr20">
            <el-form-item label="培训内容" prop="trainingContent">
              <quillEditor
                v-if="$route.query.type != 'check'"
                v-model="form.trainingContent"
                ref="myQuillEditor"
                :options="editorOption"
              ></quillEditor>
              <div v-else v-html="form.trainingContent"></div>
            </el-form-item>
          </el-col>
        </el-row>

        <!--培训资料  -->
        <div class="f--c mb20">
          <h2>
            培训资料
            <span class="required">*</span>
          </h2>
          <div class="hr"></div>
        </div>
        <el-button
          v-if="$route.query.type == 'edit'"
          type="primary"
          icon="el-icon-plus"
          @click="showAddData"
        >关联培训资料
        </el-button>
        <el-table :data="dataList2" style="width: 100%;margin:20px 0px;">
          <el-table-column prop="dataName" label="资料名称"></el-table-column>
          <el-table-column
            prop="categoryName"
            label="专业类别"
          ></el-table-column>
          <el-table-column label="操作" v-if="$route.query.type == 'edit'">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="delData(scope.$index)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <!--关联考试  -->
        <div class="f--c mb20">
          <h2>关联考试</h2>
          <div class="hr"></div>
        </div>
        <el-button
          v-if="$route.query.type == 'edit'"
          type="primary"
          icon="el-icon-plus"
          @click="showCorrelationExam"
        >关联考试
        </el-button
        >
        <el-table :data="dataList3" style="width: 100%;margin:20px 0px;">
          <el-table-column
            prop="questionsPaperName"
            label="试卷名称"
          ></el-table-column>
          <el-table-column label="试卷类型">
            <template slot-scope="scope">{{
                scope.row.selectionMode == 0 ? "随机试卷" : "固定试卷"
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="questionNumber"
            label="包含题目数量"
          ></el-table-column>
          <el-table-column label="操作" v-if="$route.query.type == 'edit'">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="delPaper(scope.$index)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="searchBut">
          <el-button
            v-if="$route.query.type == 'edit'"
            type="primary"
            :loading="saveLoading"
            @click="save"
          >保存
          </el-button
          >
          <el-button type="primary" @click="$router.back(-1)">返回</el-button>
        </div>
      </el-form>
    </div>


    <!--关联课件选择-->
    <resourcesDataSelector ref="resourcesDataSelector" @confirm="confirm"></resourcesDataSelector>
    <!--关联考试选择-->
    <examSelector ref="examSelector" @confirm="confirm2"> </examSelector>
  </div>
</template>

<script>

import api from "../../api/new/training.js";
import api_user from "../../api/api_user.js";
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
import {quillEditor} from "vue-quill-editor";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";
import resourcesDataSelector from '@/pages/trainingManagement/component/resourcesDataSelector.vue';
import examSelector from '@/pages/trainingManagement/component/examSelector.vue';



/*富文本编辑图片上传配置*/
const uploadConfig = {
  action: process.env.API_ROOT + "/clouddo-tranning/training/record/upload", // 必填参数 图片上传地址
  methods: "POST", // 必填参数 图片上传方式
  // token: window.localStorage.getItem("access-token"), // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: "file", // 必填参数 文件的参数名
  size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: "image/png, image/gif, image/jpeg, image/bmp, image/x-icon" // 可选 可上传的图片格式
};
const handlers = {
  image: function image() {
    var self = this;

    var fileInput = this.container.querySelector("input.ql-image[type=file]");
    if (fileInput === null) {
      fileInput = document.createElement("input");
      fileInput.setAttribute("type", "file");
      // 设置图片参数名
      if (uploadConfig.name) {
        fileInput.setAttribute("name", uploadConfig.name);
      }
      // 可设置上传图片的格式
      fileInput.setAttribute("accept", uploadConfig.accept);
      fileInput.classList.add("ql-image");
      // 监听选择文件
      fileInput.addEventListener("change", function () {
        // 创建formData
        var formData = new FormData();
        formData.append(uploadConfig.name, fileInput.files[0]);
        formData.append("object", "product");
        // 如果需要token且存在token
        if (uploadConfig.token) {
          formData.append("token", uploadConfig.token);
        }
        // 图片上传
        var xhr = new XMLHttpRequest();
        xhr.open(uploadConfig.methods, uploadConfig.action, true);
        xhr.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("access-token")
        );
        // 上传数据成功，会触发
        xhr.onload = function (e) {
          if (xhr.status === 200) {
            var res = JSON.parse(xhr.responseText);
            let length = self.quill.getSelection(true).index;
            //这里很重要，你图片上传成功后，img的src需要在这里添加，res.path就是你服务器返回的图片链接。
            console.log(res.data);
            self.quill.insertEmbed(length, "image", "http://" + res.data);
            self.quill.setSelection(length + 1);
          }
          fileInput.value = "";
        };
        // 开始上传数据
        xhr.upload.onloadstart = function (e) {
          fileInput.value = "";
        };
        // 当发生网络异常的时候会触发，如果上传数据的过程还未结束
        xhr.upload.onerror = function (e) {
        };
        // 上传数据完成（成功或者失败）时会触发
        xhr.upload.onloadend = function (e) {
          // console.log('上传结束')
        };
        xhr.send(formData);
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};
// toolbar工具栏的工具选项（默认展示全部）
const toolOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{header: 1}, {header: 2}],
  [{list: "ordered"}, {list: "bullet"}],
  [{script: "sub"}, {script: "super"}],
  [{indent: "-1"}, {indent: "+1"}],
  [{direction: "rtl"}],
  [{size: ["small", false, "large", "huge"]}],
  [{header: [1, 2, 3, 4, 5, 6, false]}],
  [{color: []}, {background: []}],
  [{font: []}],
  [{align: []}],
  ["clean"],
  ["image"]
];


export default {
  components: {quillEditor, selectTree, selectTrainingCategory, resourcesDataSelector, examSelector},
  data() {
    return {
      id: undefined, //
      type: undefined, //
      form: {
        trainingName: undefined,
        implementationDateTime: undefined,
        // departmentId: undefined,
        department: undefined,
        principalId: undefined,
        // principalName: undefined,
        location: undefined,
        trainingContent: undefined,
        directoryId: undefined,
        directoryName: undefined,

        // training category
        trainingLevelIds: undefined,
        trainingLevelName: undefined,
        trainingIndustryIds: undefined,
        trainingIndustryName: undefined,
        trainingPostIds: undefined,
        trainingPostName: undefined,
        trainingTypeIds: undefined,
        trainingTypeName: undefined,
        trainingCategoryName: undefined
      },
      rules: {
        trainingName: [
          {required: true, message: "请输入培训名称", trigger: "blur"},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        directoryId: [{required: true, message: "请选择课程目录"}],
        trainingContent: [{required: true, message: "请输入培训内容"}],
        trainingCategoryName: [{required: true, message: "请选择课程类型", trigger: "blur"}]
        // implementationDateTime: [{ required: true, message: "请输入", trigger: "blur" }],
        // principalId: [{ required: true, message: "请输入" }],
        // departmentId: [{ required: true, message: "请输入" }]
      },
      correlationExamForm: {
        openBook: undefined,
        selectionMode: undefined,
        questionsPaperName: undefined
      },

      principalList: [], // 负责人列表
      departmentList: [], // 部门列表
      categoryList: [],

      dataForm: {
        dataName: undefined,
        professionalCategory: undefined, // 专业类别
        departmentId: undefined // 部门id
      },
      dataList: [], // 课程资源列表
      selectDataList: [], // 选择的课程资源列表
      selectPaperList: [], // 选择的试卷列表
      dataList2: [], //培训资料列表
      dataList3: [], //试卷列表

      isShowData: false,
      isShowCorrelationExam: false,
      saveLoading: false,

      paperList: [], // 试卷列表
      annexList: [], //附件列表

      uploadUrl: "",
      headers: {
        Authorization: ""
      },

      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      page2: 1,
      pageSize2: 20,
      total2: 0,

      deptTree: [],
      dept: {},
      catalogList: [], // 试题目录
      editorOption: {
        //  富文本编辑器配置
        placeholder: "",
        theme: "snow", // 主题
        modules: {
          // 新增下面
          imageDrop: true, // 拖动加载图片组件。
          imageResize: {
            //调整大小组件。
            displayStyles: {
              backgroundColor: "black",
              border: "none",
              color: "white"
            },
            modules: ["Resize", "DisplaySize", "Toolbar"]
          },
          toolbar: {
            container: toolOptions, // 工具栏选项
            // handlers: handlers // 事件重写
          }
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        imageDrop: true,
        imageResize: {
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        }
      }
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    if (this.id) this.getProgramDetail();
    this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.uploadUrl =
      process.env.API_ROOT + "/clouddo-tranning/training/resources/data/upload";
    this.headers.Authorization = window.localStorage.getItem("access-token");
    this.getCatalogList();
  },
  methods: {
    getCatalogList() {
      exam.getCatalogList({
        type: 4,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
          .enterpriseId
      })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.form.directoryId = v.id
      this.form.directoryName = v.text;
    },
    deptChange(v) {
      this.dept = v;
      this.form.departmentId = v.id;
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    pageChange2(e) {
      this.page2 = e;
      this.getPaperList();
    },
    getProgramDetail() {
      api.getProgramDetail({programId: this.id}).then(res => {
        this.form.trainingName = res.data.trainingName;
        this.form.implementationDateTime = res.data.implementationTime;
        this.form.departmentId = parseInt(res.data.departmentId);
        this.form.department = res.data.department;
        if (res.data.principalId) {
          this.form.principalId = parseInt(res.data.principalId);
        }
        this.form.principalName = res.data.principalName;
        this.form.location = res.data.location;
        this.form.trainingContent = res.data.trainingContent;
        this.form.directoryId = res.data.directoryId;

        this.annexList = res.data.annexList;

        this.form.teachersId = res.data.teachersId;
        this.form.trainingLevelName = res.data.trainingLevelName;
        this.form.trainingIndustryName = res.data.trainingIndustryName;
        this.form.trainingPostName = res.data.trainingPostName;
        this.form.trainingTypeName = res.data.trainingTypeName;
        this.form.trainingCategoryName = res.data.trainingCategoryName;


        res.data.trainingProgramJoinDataVos.forEach(v => {
          this.categoryList.forEach(v2 => {
            if (v.professionalCategory == v2.code) {
              v.categoryName = v2.text;
            }
          });
        });
        this.dataList2 = res.data.trainingProgramJoinDataVos;

        res.data.trainingProgramJoinPaperVos.forEach(v => {
          v.questionNumber = v.questionsNumber;
        });
        this.dataList3 = res.data.trainingProgramJoinPaperVos;
      });
    },
    save() {
      this.$refs.form.validate(validate => {
        //if (validate == false) return this.$message.error("请填写表单");

        let p = {
          ...this.form,
          trainingProgramJoinDataSaveDtos: [],
          trainingProgramJoinPaperSaveDtos: [],
          annexList: this.annexList,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        };
        delete p.trainingCategoryName;

        this.dataList2.forEach(v => {
          p.trainingProgramJoinDataSaveDtos.push({
            trainingResourcesDataId: v.id ? v.id : v.trainingResourcesDataId,
            dataName: v.dataName,
            professionalCategory: v.professionalCategory,
            department: v.department,
            departmentId: v.departmentId
          });
        });
        this.dataList3.forEach(v => {
          p.trainingProgramJoinPaperSaveDtos.push({
            questionsPaperId: v.id || v.questionsPaperId,
            questionsPaperName: v.questionsPaperName,
            questionsPaperType:
              v.selectionMode !== undefined
                ? v.selectionMode
                : v.questionsPaperType,
            questionsNumber:
              v.questionsNumber !== undefined
                ? v.questionsNumber
                : v.questionNumber
          });
          console.log(v.selectionMode || v.questionsPaperType);
          console.log(v.selectionMode || v.questionsPaperType);
        });

        // p.principalName = this.principalList.filter((v, i) => {
        //   return v.id == this.form.principalId;
        // })[0].userName;

        this.departmentList.forEach(v => {
          if (p.departmentId == v.id) p.department = v.deptName;
        });

        if (this.id) p.id = this.id;
        if (p.trainingProgramJoinDataSaveDtos.length == 0)
          return this.$message.error("请添加培训资料");

        this.saveLoading = true;
        api.addProgram(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.saveLoading = false;
            this.$message.error(res.message);
          }
        });
      });
    },
    //上传文件成功回调
    uploadSuccess(e) {
      if (e.code == 0) {
        this.annexList.push(e.data);
      } else {
        this.$message.error(e.message);
      }
    },
    delData(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dataList2.splice(index, 1);
      });
    },
    delPaper(index) {
      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dataList3.splice(index, 1);
      });
    },
    // 添加培训资料,确定
    confirm(selectDataList) {
      this.dataList2 = [];
      selectDataList.forEach(v => {
        this.dataList2.push(v);
      });
    },
    // 关联考试,确定
    confirm2(selectDataList) {
      this.dataList3 = [];
      selectDataList.forEach(v => {
        this.dataList3.push(v);
      });
    },
    selectionChange(e) {
      this.selectDataList = e;
    },
    selectionChange2(e) {
      this.selectPaperList = e;
    },

    showAddData() {
      this.$refs.resourcesDataSelector.show();
      this.$refs.resourcesDataSelector.setSelection(this.dataList2);
    },
    showCorrelationExam() {
      this.$refs.examSelector.show();
      this.$refs.examSelector.setSelection(this.dataList3);
    },
    getPaperList() {
      let p = {
        ...this.correlationExamForm,
        page: this.page,
        pageSize: this.pageSize,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      exam.getPaperList(p).then(res => {
        this.paperList = res.data.records;
        this.total2 = res.data.total;
      });
    },
    //获取资料列表
    getDataList() {
      let p = {
        page: this.page2,
        pageSize: this.pageSize2,
        isAble: 0,
        ...this.dataForm,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };

      api.getDataList(p).then(res => {
        let list = res.data.records;
        list.forEach(v => {
          this.categoryList.forEach(v2 => {
            if (v.professionalCategory == v2.code) {
              v.categoryName = v2.text;
            }
          });
        });

        this.dataList = list;
        this.total = res.data.total;
      });
    },
    //重置表单
    resetForm(formName) {
      console.log(formName);
      this.$refs[formName].resetFields();
    },

    selectTrainingCategorySubmitHandle(data) {
      this.form.trainingLevelIds = [data.trainingLevelId];
      this.form.trainingLevelName = data.trainingLevelName;

      this.form.trainingIndustryIds = [data.trainingIndustryId];
      this.form.trainingIndustryName = data.trainingIndustryName;

      this.form.trainingPostIds = [data.trainingPostId];
      this.form.trainingPostName = data.trainingPostName;

      this.form.trainingTypeIds = [data.trainingTypeId];
      this.form.trainingTypeName = data.trainingTypeName;

      this.form.trainingCategoryName = data.trainingCategoryName;

      this.$refs.form.validateField("trainingCategoryName");
    },
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    }
  },
  watch: {
    "form.departmentId": function (deptId) {
      api_user.getByDept({deptId}).then(res => {
        this.principalList = res.data;
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/trainingManagement/addProgram.vue